import { Card, CardContent, Typography, Stack } from '@mui/material';
import { PaymentLineItemRow } from './PaymentLineItemRow';

export interface PaymentLineItem {
  id: string;
  name: string;
  amount: number;
  type: 'split' | 'dayRate' | 'solo';
}

interface PaymentBreakdownCardProps {
  items: PaymentLineItem[];
}

export function PaymentBreakdownCard({ items }: PaymentBreakdownCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Payment Breakdown
        </Typography>
        <Stack spacing={1.5}>
          {items.map(item => (
            <PaymentLineItemRow
              key={item.id}
              name={item.name}
              amount={item.amount}
              subtitle={item.type === 'dayRate' ? 'Day Rate' : undefined}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
